import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Layout } from '@/components/layout'
import { ModuleGuard } from '@/components/module-guard'

export const Route = createFileRoute('/crm')({
  component: CrmLayout,
})

function CrmLayout() {
  return (
    <Layout>
      <ModuleGuard moduleKey="crm">
        <Outlet />
      </ModuleGuard>
    </Layout>
  )
}
